
import {Component} from 'argo-js/src/view/Component';
import {Utils} from 'argo-js/src/common/Utils';

const tplModal = require('../templates/modal.hbs');

export class DynamicModal extends Component {

  constructor(config) {
    super({
      id: 'dynamicModal',
      tpl: tplModal,
      container: 'body',
      ui: {
        body: '.modal-body',
        submit: '.js-submit'
      },
      events: {
        'click @submit': '_handleSubmit',
      },
      autoInit: false,
      settings: {
        css: false,
        centered: true,
        fade: true,
        contentTag: 'div',
        contentCss: '',
        title: '',
        hideClose: false,
        closeLabel: 'modal.closeLabel',
        abortLabel: 'modal.abortLabel',
        abortStyle: 'outline-secondary',
        submitLabel: 'modal.submitLabel',
        submitStyle: 'success',
        hideFooter: false,
        dataComponent: null
      },
      show: true,
      preventClose: false,
      options: {
        backdrop: true,
        keyboard: true
      }
    }, config);

    this.content = this.config.content || '';
    this.$container = $(this.config.container);
    this.subcomponents = [];
    this.dismiss = true;

    if (this.config.show) {
      this.show();
    }
  }

  _handleSubmit() {
    this.dismiss = false;
    this.subcomponents.forEach((comp) => comp.trigger('modal:submit'));
    this.triggerMethodOn('submit', this);
  }

  show() {

    this.triggerMethodOn('beforeShow', this);

    let modalOptions = this.config.options;
    let cfg = $.extend(true, {
      id: this.config.id,
      body: Utils.isString(this.content) ? this.content : ''
    }, this.config.settings);

    // prevent user from closing the modal
    if (this.config.preventClose) {
      cfg.hideClose = true; // close button
      modalOptions.backdrop = 'static';
      modalOptions.keyboard = false;
    }

    ['title', 'closeLabel', 'abortLabel', 'submitLabel'].forEach((key) => {
      if (cfg[key]) cfg[key] = this.t(cfg[key]);
    });

    let modal = this.config.tpl(cfg);
    this.el = $(modal);
    this.init();
    if (this.app) {
      this.subcomponents = this.app.initComponents(this.ui.body);
    }

    if (!Utils.isUndefOrNull(this.content) && !Utils.isString(this.content)) {
      this.ui.body.append(this.content);
    }

    this.el
      .appendTo(this.$container)
      .on('shown.bs.modal', () => {
        let $drop = this.el.next('.modal-backdrop').detach();
        this.el.before($drop);
        this.el.css('z-index', 1040);
      })
      .on('hidden.bs.modal', () => {
        this.el.detach();
        this.subcomponents.forEach((comp) => comp.trigger('modal:close'));
        this.triggerMethodOn('close', [this, this.dismiss]);

        // fix scrollbar if more than one dialog is open
        if ($('.modal-backdrop').length) {
          $('body').addClass('modal-open');
        }
      })
      .modal(modalOptions);

    this.triggerMethodOn('show', this);
  }

  close() {
    if (this.triggerMethodOn('beforeClose', [this, this.dismiss]) === false) {
      return;
    }

    this.el.modal('hide');
  }

}